import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const personSearchRoutes: RouteObject[] = [
  {
    path: '/person-search',
    element: lazyElement(() => import('./Main')),
    handle: {
      documentTitle: 'Numbers for Name',
      crumb: () => ({ label: 'Numbers for Name', to: '/person-search' })
    },
  },
  {
    path: '/person-search/history',
    element: lazyElement(() => import('./History')),
    handle: {
      documentTitle: 'History',
      crumb: () => ({ label: 'History', to: '/person-search/history' })
    },
  },
];

export default personSearchRoutes;
